<span class="cursor-pointer inline-block bg-col-5 p2 quick-link"
      [ngClass]="filter.isSelected(primaryTag) ? 'col-1' : 'col-12'"
      (click)="primaryTag ? filter.toggle(primaryTag) : filter.reset()">{{primaryTag || 'All'}}</span>